import { D, st, toArr } from '../constants';
import { StatGrid, InvoiceBadge } from './shared';

export default function Payments({invoices, clientName, calcTotal, fmtDate, fmt, apiUpdateInvoice, setPage}) {
  const paid = toArr(invoices).filter(i => i.status === "Paid");
  const unpaid = toArr(invoices).filter(i => i.status !== "Paid");

  const markPaid = async (id) => {
    const paidDate = new Date().toISOString().slice(0,10);
    await apiUpdateInvoice(id, { status: "Paid", paidDate });
  };

  const goToInvoice = () => setPage("invoices");

  return (
    <div>
      <div style={st.h1}>Payments</div>
      <StatGrid stats={[
        { label: "Total collected", value: fmt(paid.reduce((s,i)=>s+calcTotal(i.items),0)), color: D.success },
        { label: "Outstanding", value: fmt(unpaid.reduce((s,i)=>s+calcTotal(i.items),0)), color: D.warning },
        { label: "Overdue invoices", value: toArr(invoices).filter(i=>i.status==="Overdue").length, color: D.danger },
      ]}/>

      <div style={st.h2}>Unpaid</div>
      <div style={{...st.card, marginBottom:24}}>
        <div style={{overflowX:"auto"}}><table style={st.table}>
          <thead><tr>{["Invoice","Client","Due","Amount","Status",""].map(h=><th key={h} style={st.th}>{h}</th>)}</tr></thead>
          <tbody>
            {unpaid.length ? unpaid.map(inv => (
              <tr key={inv.id}>
                <td style={st.td}><span style={{color:D.accent,cursor:"pointer",textDecoration:"underline"}} onClick={goToInvoice}>{inv.number}</span></td>
                <td style={st.td}>{clientName(inv.clientId)}</td>
                <td style={st.td}>{fmtDate(inv.dueDate)}</td>
                <td style={st.td}>{fmt(calcTotal(inv.items))}</td>
                <td style={st.td}><InvoiceBadge status={inv.status}/></td>
                <td style={st.td}><button style={st.btn("success")} onClick={()=>markPaid(inv.id)}>Mark Paid</button></td>
              </tr>
            )) : (
              <tr><td colSpan={6} style={{...st.td,color:D.muted,textAlign:"center"}}>All caught up!</td></tr>
            )}
          </tbody>
        </table></div>
      </div>

      <div style={st.h2}>Payment history</div>
      <div style={st.card}>
        <div style={{overflowX:"auto"}}><table style={st.table}>
          <thead><tr>{["Invoice","Client","Paid on","Amount"].map(h=><th key={h} style={st.th}>{h}</th>)}</tr></thead>
          <tbody>
            {paid.map(inv => (
              <tr key={inv.id}>
                <td style={st.td}><span style={{color:D.accent,cursor:"pointer",textDecoration:"underline"}} onClick={goToInvoice}>{inv.number}</span></td>
                <td style={st.td}>{clientName(inv.clientId)}</td>
                <td style={st.td}>{fmtDate(inv.paidDate)}</td>
                <td style={{...st.td,color:D.success,fontWeight:500}}>{fmt(calcTotal(inv.items))}</td>
              </tr>
            ))}
          </tbody>
        </table></div>
        {paid.length===0 && <div style={{color:D.muted,textAlign:"center",padding:"20px 0"}}>No payments recorded yet.</div>}
      </div>
    </div>
  );
}
